import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class GroupInsertService {

  private apiUrl = globalConst.baseAPI;  // URL para web api

  constructor(private http: Http) { }

  searchPermissions(token) {

    return this.http
      .get(this.apiUrl + "/permissions/v1/getpermissions?$orderby=Processo,Descricao&$active eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  insertGroup(token, data: any) {

    return this.http
      .post(this.apiUrl + "groups/v1/insertgroup", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/group/service/group-insert/group-insert.service.ts